// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { DateSpan, DateTime } from "generated/mos/date";
import { Codec, DecodeContext, RemoteObject, Timestamp, WebRPCError, decodeMessageRepeated, ensureScalar, ensureScalarOptional, ensureScalarRepeated } from "generated/webrpc";

export namespace Calendar {
  export const refName = "mos.org.getty.integration.Calendar" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly kind: Calendar.CalendarKind | Calendar.UnknownCalendar.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    kind: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      {
        const uv: any = v.kind;
        if (uv !== undefined) {
          if (Calendar.CalendarKindValues.has(uv)) {
            obj["calendarKind"] = uv;
          }
          else if (uv.type == "mos.org.getty.integration.Calendar.UnknownCalendar") {
            obj["unknownCalendar"] = Calendar.UnknownCalendar.codec.encode(uv);
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.org.getty.integration.Calendar.kind");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.Calendar");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      {
        if (v["calendarKind"] !== undefined) {
          {
            const ev = ensureScalar(ctx, v["calendarKind"], "string") || defaults["kind"];
            if (!Calendar.CalendarKindValues.has(ev as any)) {
              throw ctx.error(`unknown value "${ev}" for enum .mos.org.getty.integration.Calendar.CalendarKind`);
            }
            out["kind"] = ev as any;
          }
        }
        if (v["unknownCalendar"] !== undefined) {
          out["kind"] = ctx.decode(Calendar.UnknownCalendar.codec, v["unknownCalendar"], "unknownCalendar");
        }
      }
      return out as any as Entity;
    }
  }();
  export namespace UnknownCalendar {
    export const refName = "mos.org.getty.integration.Calendar.UnknownCalendar" as const;
    export type Entity = {
      readonly type: typeof refName,
      readonly id: number,
      readonly name: string,
    }
    export const defaults: Entity = {
      type: refName,
      id: 0,
      name: "",
    }
    export const codec: Codec<Entity> = new class {
      public encode(v: Entity): RemoteObject;
      public encode(v: Entity | undefined): RemoteObject | null {
        if (!v) return null;
        const { type, ...out } = v;
        return out;
      }
      public decode(v: RemoteObject): Entity;
      public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
        if (v === undefined || v === null) return undefined;
        if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.Calendar.UnknownCalendar");
        if (typeof(v) !== "object") throw ctx.expected("object", v);
        const out: RemoteObject = { ...defaults };
        out["id"] = ensureScalar(ctx, v["id"], "number");
        out["name"] = ensureScalar(ctx, v["name"], "string");
        return out as any as Entity;
      }
    }();
  }

  export const CalendarKindValues = new Set([
    'CALENDAR_UNPECIFIED' as const,
    'CALENDAR_EXHIBITIONS' as const,
    'CALENDAR_PERFORMANCES' as const,
    'CALENDAR_FILM' as const,
    'CALENDAR_FAMILY' as const,
    'CALENDAR_FOOD' as const,
    'CALENDAR_TOURS' as const,
    'CALENDAR_TALKS' as const,
    'CALENDAR_COURSES' as const,
  ]);
  export type CalendarKind = typeof CalendarKindValues extends Set<infer U> ? U : never;

}

export namespace GetGetty360EventRequest {
  export const refName = "mos.org.getty.integration.GetGetty360EventRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly getty360EventRef: { readonly typename: 'mos.org.getty.integration.Getty360Event', readonly id: string } | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    getty360EventRef: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.GetGetty360EventRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["getty360EventRef"] = v["getty360EventRef"];
      return out as any as Entity;
    }
  }();
}

export namespace GetGetty360EventResponse {
  export const refName = "mos.org.getty.integration.GetGetty360EventResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly getty360Event: Getty360Event.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    getty360Event: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["getty360Event"] = Getty360Event.codec.encode(v.getty360Event);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.GetGetty360EventResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["getty360Event"] = ctx.decode(Getty360Event.codec, v["getty360Event"], "getty360Event");
      return out as any as Entity;
    }
  }();
}

export namespace Getty360Event {
  export type Ref = { readonly typename: 'mos.org.getty.integration.Getty360Event', readonly id: string };
  export function isRef(v: { typename: string, id: string } | undefined): v is Ref {
    return !!v && typeof v.id === "string" && (v.typename === 'mos.org.getty.integration.Getty360Event');
  }
  export function mustRef(v: { typename: string, id: string } | undefined): Ref {
    if (!isRef(v)) throw new WebRPCError(`Ref ${v && v.typename}:${v && v.id} is not a valid ref for a Getty360Event`);
    return v;
  }
  export const refName = "mos.org.getty.integration.Getty360Event" as const;
  export type Entity = {
    readonly type: typeof refName,
    // XXX: Field ordering here follows the order in the openapi.json file in the
    // properties. This file is provided by Getty and may be out of date.
    readonly ref: { readonly typename: 'mos.org.getty.integration.Getty360Event', readonly id: string } | undefined,
    readonly eventId: number,
    readonly calendars: ReadonlyArray<Calendar.Entity>,
    // From the Getty OpenAPI docs:
    // 
    // > This ID is created by Getty systems external to the 360 calendar and is
    // > added to the event record manually. TODO fix this
    // 
    // The Getty API returns a comma separated list of strings for this, which
    // we separate:
    readonly exhibitionIds: ReadonlyArray<string>,
    // The full event title. Getty's representation of this can contain HTML,
    // but we strip it out before surfacing it through this message.
    readonly title: string,
    // A short title for the event. Can be used for lists or mobile displays.
    // Getty's data is not meant to include HTML, but we strip it just the same.
    readonly shortTitle: string,
    readonly seriesTitle: string,
    // The event's complete description. Getty's docs indicate this can include
    // styling HTML.
    readonly description: string,
    readonly shortDescription: string,
    // A string identifying the location of event.
    readonly location: string,
    // A string indicating the site of the event, usually 'Getty Center' or 'Getty
    // Villa'.
    readonly site: string,
    // A URL for a site or information resource related to the event's location.
    // This is used for events occuring outside the Getty campuses which occur
    // rarely.
    readonly locationUrl: string,
    // Combines eventStartDate and eventEndDate
    readonly dateSpan: DateSpan.Entity | undefined,
    // The getty.edu tickets system ID for an event. This can be used to
    // construct the URL for the tickets system. An id of *73928* would be
    // appended to *http://tickets.getty.edu/loader.aspx/?target=hall.aspx?event=* to create
    // *http://tickets.getty.edu/loader.aspx/?target=hall.aspx?event=73928*
    readonly ticketId: string,
    // URL for the getty.edu ticket system page for this event. Tickets can be
    // purchased or reserved.
    // example: http://tickets.getty.edu/loader.aspx/?target=hall.aspx?event=52173
    readonly ticketUrl: string,
    readonly ticketInfo: string,
    // Same as above, but has vertical pipes replaced with commas for accessibility screen readers
    readonly ticketInfoAccessibility: string,
    readonly ticketRequiredText: string,
    // is_ticket_required was added by Getty at Art Processors' request.
    // 
    // This was intended to denote that a BYOD user should be shown a link to the event
    // page on the website which contains more detailed information about tickets.
    // 
    // In-house users have already purchased entrance and thus do not need to be asked to
    // purchase admission. Additionally, in-house devices should not link out to the web.
    readonly isTicketRequired: boolean,
    // is_paid_ticket was added by Getty at Art Processors' request.
    readonly isPaidTicket: boolean,
    readonly canceled: boolean,
    readonly soldOut: boolean,
    readonly learnMoreUrl: string,
    // Full URL for event's detail page on the getty.edu website.
    readonly eventDetailUrl: string,
    readonly isOngoing: boolean,
    readonly isReoccurring: boolean,
    // If the image returned by the Getty 360 API is a placeholder (and we are
    // able to detect it), this will be empty:
    readonly imageUrl: string,
    // URL for a large event image, 870px wide. See image_url for details about
    // placeholders.
    readonly imageBigUrl: string,
    // URL for a wide event image, 800x286. Only present occasionally. See
    // image_url for details about placeholders.
    readonly imageWideUrl: string,
    // URL for a square event image, 417x417. See image_url for details about placeholders.
    readonly imageSquareUrl: string,
    // URL for a small square event image, 135x135.
    readonly imageSmallSquareUrl: string,
    // Image Credit information, including copyright info, etc.
    readonly imageCredit: string,
    readonly imageCaption: string,
    // All occurrences from the getty360 endpoint.
    readonly allOccurrences: ReadonlyArray<DateTime.Entity>,
    readonly ticketType: string,
    // All event times for the day, as found in all_occurrences, based on the server's
    // understanding of the current time in 'America/Los_Angeles'.
    readonly todaysOccurrences: ReadonlyArray<DateTime.Entity>,
    readonly updatedAt: Timestamp | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    ref: undefined,
    eventId: 0,
    calendars: [],
    exhibitionIds: [],
    title: "",
    shortTitle: "",
    seriesTitle: "",
    description: "",
    shortDescription: "",
    location: "",
    site: "",
    locationUrl: "",
    dateSpan: undefined,
    ticketId: "",
    ticketUrl: "",
    ticketInfo: "",
    ticketInfoAccessibility: "",
    ticketRequiredText: "",
    isTicketRequired: false,
    isPaidTicket: false,
    canceled: false,
    soldOut: false,
    learnMoreUrl: "",
    eventDetailUrl: "",
    isOngoing: false,
    isReoccurring: false,
    imageUrl: "",
    imageBigUrl: "",
    imageWideUrl: "",
    imageSquareUrl: "",
    imageSmallSquareUrl: "",
    imageCredit: "",
    imageCaption: "",
    allOccurrences: [],
    ticketType: "",
    todaysOccurrences: [],
    updatedAt: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["ref"] = v.ref;
      obj["eventId"] = v.eventId;
      obj["calendars"] = [];
      for (const item of v.calendars) {
        obj["calendars"].push(Calendar.codec.encode(item));
      }
      obj["exhibitionIds"] = v.exhibitionIds;
      obj["title"] = v.title;
      obj["shortTitle"] = v.shortTitle;
      obj["seriesTitle"] = v.seriesTitle;
      obj["description"] = v.description;
      obj["shortDescription"] = v.shortDescription;
      obj["location"] = v.location;
      obj["site"] = v.site;
      obj["locationUrl"] = v.locationUrl;
      obj["dateSpan"] = DateSpan.codec.encode(v.dateSpan);
      obj["ticketId"] = v.ticketId;
      obj["ticketUrl"] = v.ticketUrl;
      obj["ticketInfo"] = v.ticketInfo;
      obj["ticketInfoAccessibility"] = v.ticketInfoAccessibility;
      obj["ticketRequiredText"] = v.ticketRequiredText;
      obj["isTicketRequired"] = v.isTicketRequired;
      obj["isPaidTicket"] = v.isPaidTicket;
      obj["canceled"] = v.canceled;
      obj["soldOut"] = v.soldOut;
      obj["learnMoreUrl"] = v.learnMoreUrl;
      obj["eventDetailUrl"] = v.eventDetailUrl;
      obj["isOngoing"] = v.isOngoing;
      obj["isReoccurring"] = v.isReoccurring;
      obj["imageUrl"] = v.imageUrl;
      obj["imageBigUrl"] = v.imageBigUrl;
      obj["imageWideUrl"] = v.imageWideUrl;
      obj["imageSquareUrl"] = v.imageSquareUrl;
      obj["imageSmallSquareUrl"] = v.imageSmallSquareUrl;
      obj["imageCredit"] = v.imageCredit;
      obj["imageCaption"] = v.imageCaption;
      obj["allOccurrences"] = [];
      for (const item of v.allOccurrences) {
        obj["allOccurrences"].push(DateTime.codec.encode(item));
      }
      obj["ticketType"] = v.ticketType;
      obj["todaysOccurrences"] = [];
      for (const item of v.todaysOccurrences) {
        obj["todaysOccurrences"].push(DateTime.codec.encode(item));
      }
      obj["updatedAt"] = v.updatedAt ? v.updatedAt.value : "";
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.Getty360Event");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["ref"] = v["ref"];
      out["eventId"] = ensureScalar(ctx, v["eventId"], "number");
      out["calendars"] = decodeMessageRepeated(ctx, Calendar.codec, v["calendars"], "calendars");
      out["exhibitionIds"] = ensureScalarRepeated(ctx, v["exhibitionIds"], "string");
      out["title"] = ensureScalar(ctx, v["title"], "string");
      out["shortTitle"] = ensureScalar(ctx, v["shortTitle"], "string");
      out["seriesTitle"] = ensureScalar(ctx, v["seriesTitle"], "string");
      out["description"] = ensureScalar(ctx, v["description"], "string");
      out["shortDescription"] = ensureScalar(ctx, v["shortDescription"], "string");
      out["location"] = ensureScalar(ctx, v["location"], "string");
      out["site"] = ensureScalar(ctx, v["site"], "string");
      out["locationUrl"] = ensureScalar(ctx, v["locationUrl"], "string");
      out["dateSpan"] = ctx.decode(DateSpan.codec, v["dateSpan"], "dateSpan");
      out["ticketId"] = ensureScalar(ctx, v["ticketId"], "string");
      out["ticketUrl"] = ensureScalar(ctx, v["ticketUrl"], "string");
      out["ticketInfo"] = ensureScalar(ctx, v["ticketInfo"], "string");
      out["ticketInfoAccessibility"] = ensureScalar(ctx, v["ticketInfoAccessibility"], "string");
      out["ticketRequiredText"] = ensureScalar(ctx, v["ticketRequiredText"], "string");
      out["isTicketRequired"] = ensureScalar(ctx, v["isTicketRequired"], "boolean");
      out["isPaidTicket"] = ensureScalar(ctx, v["isPaidTicket"], "boolean");
      out["canceled"] = ensureScalar(ctx, v["canceled"], "boolean");
      out["soldOut"] = ensureScalar(ctx, v["soldOut"], "boolean");
      out["learnMoreUrl"] = ensureScalar(ctx, v["learnMoreUrl"], "string");
      out["eventDetailUrl"] = ensureScalar(ctx, v["eventDetailUrl"], "string");
      out["isOngoing"] = ensureScalar(ctx, v["isOngoing"], "boolean");
      out["isReoccurring"] = ensureScalar(ctx, v["isReoccurring"], "boolean");
      out["imageUrl"] = ensureScalar(ctx, v["imageUrl"], "string");
      out["imageBigUrl"] = ensureScalar(ctx, v["imageBigUrl"], "string");
      out["imageWideUrl"] = ensureScalar(ctx, v["imageWideUrl"], "string");
      out["imageSquareUrl"] = ensureScalar(ctx, v["imageSquareUrl"], "string");
      out["imageSmallSquareUrl"] = ensureScalar(ctx, v["imageSmallSquareUrl"], "string");
      out["imageCredit"] = ensureScalar(ctx, v["imageCredit"], "string");
      out["imageCaption"] = ensureScalar(ctx, v["imageCaption"], "string");
      out["allOccurrences"] = decodeMessageRepeated(ctx, DateTime.codec, v["allOccurrences"], "allOccurrences");
      out["ticketType"] = ensureScalar(ctx, v["ticketType"], "string");
      out["todaysOccurrences"] = decodeMessageRepeated(ctx, DateTime.codec, v["todaysOccurrences"], "todaysOccurrences");
      {
        const tsv = ensureScalarOptional(ctx, v["updatedAt"], "string");
        out["updatedAt"] = tsv ? {type: "google.protobuf.Timestamp", value: tsv} : undefined;
      }
      return out as any as Entity;
    }
  }();
}

export namespace ListGetty360EventsRequest {
  export const refName = "mos.org.getty.integration.ListGetty360EventsRequest" as const;
  export type Entity = {
    readonly type: typeof refName,
  }
  export const defaults: Entity = {
    type: refName,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.ListGetty360EventsRequest");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      return out as any as Entity;
    }
  }();
}

export namespace ListGetty360EventsResponse {
  export const refName = "mos.org.getty.integration.ListGetty360EventsResponse" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly getty360Events: ReadonlyArray<Getty360Event.Entity>,
  }
  export const defaults: Entity = {
    type: refName,
    getty360Events: [],
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["getty360Events"] = [];
      for (const item of v.getty360Events) {
        obj["getty360Events"].push(Getty360Event.codec.encode(item));
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.org.getty.integration.ListGetty360EventsResponse");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["getty360Events"] = decodeMessageRepeated(ctx, Getty360Event.codec, v["getty360Events"], "getty360Events");
      return out as any as Entity;
    }
  }();
}

